import jarvisAvatar from "../assets/trustjarvis.jpg";

export default function DashboardSlide() {
  return (
    <>
      {/* Background effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-avo-purple/8 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-avo-cyan/5 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-6xl w-full mx-auto relative z-10 flex flex-col items-center justify-center h-full gap-12">
        {/* Header */}
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-avo-purple/30 bg-avo-purple/10 mb-6">
            <span className="w-2 h-2 rounded-full bg-avo-purple animate-pulse" />
            <span className="text-avo-purple text-xs font-mono tracking-wider">EVOLUTION</span>
          </div>
          <h2 className="text-6xl font-bold mb-4">
            From Marketplace to{" "}
            <span className="text-gradient">Autonomy</span>
          </h2>
        </div>

        {/* Evolution timeline */}
        <div className="w-full grid grid-cols-[1fr_auto_1fr] gap-6 items-center">
          {/* Phase 1: Now */}
          <div className="relative group">
            <div className="absolute -inset-px bg-gradient-to-br from-avo-cyan/30 to-avo-purple/20 rounded-2xl opacity-60" style={{ filter: "blur(1px)" }} />
            <div className="relative bg-[#0E0E11] border border-avo-cyan/30 rounded-2xl p-8 h-full">
              <div className="absolute -top-3 left-6 bg-[#0E0E11] px-3 text-xs font-mono font-bold text-avo-cyan tracking-wider">
                NON-CONVERSATIONAL
              </div>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-xl bg-avo-cyan/10 border border-avo-cyan/30 flex items-center justify-center">
                  <span className="text-lg">📊</span>
                </div>
                <div>
                  <div className="text-xs text-avo-cyan font-mono mb-0.5">PHASE 1 — LIVE PLATFORM</div>
                  <div className="text-xl font-bold text-white">The Marketplace</div>
                </div>
              </div>
              <div className="space-y-3">
                {[
                  "AI trading agents & smart indexes",
                  "Managed funds with on-chain settlement",
                  "One-click portfolio allocation",
                  "Real-time performance tracking",
                ].map((item) => (
                  <div key={item} className="flex items-start gap-2.5">
                    <div className="w-5 h-5 rounded-full bg-avo-cyan/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <svg className="w-3 h-3 text-avo-cyan" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-base text-gray-300">{item}</span>
                  </div>
                ))}
              </div>
              <div className="mt-6 pt-4 border-t border-white/5">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-avo-green animate-pulse" />
                  <span className="text-xs text-avo-green font-mono">Live on Solana mainnet</span>
                </div>
              </div>
            </div>
          </div>

          {/* Center arrow */}
          <div className="flex flex-col items-center gap-4 py-8">
            <div className="w-px h-8 bg-gradient-to-b from-transparent to-gray-600" />
            <div className="relative">
              <div className="absolute -inset-3 bg-avo-lime/20 rounded-full blur-lg animate-pulse" />
              <div className="relative w-14 h-14 rounded-full bg-[#151518] border-2 border-avo-lime/50 flex items-center justify-center">
                <svg className="w-6 h-6 text-avo-lime" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </div>
            </div>
            <div className="w-px h-8 bg-gradient-to-b from-gray-600 to-transparent" />
          </div>

          {/* Phase 2: What's Next */}
          <div className="relative group">
            <div className="absolute -inset-px bg-gradient-to-br from-avo-lime/40 via-avo-purple/30 to-avo-cyan/30 rounded-2xl" style={{ filter: "blur(1px)" }} />
            <div className="relative bg-[#0E0E11] border border-avo-lime/30 rounded-2xl p-8 h-full">
              <div className="absolute -top-3 left-6 bg-[#0E0E11] px-3 text-xs font-mono font-bold text-avo-lime tracking-wider">
                CONVERSATIONAL
              </div>
              <div className="flex items-center gap-3 mb-5">
                <img
                  src={jarvisAvatar}
                  alt="Miles"
                  className="w-10 h-10 rounded-xl object-cover border border-avo-lime/30"
                />
                <div>
                  <div className="text-xs text-avo-lime font-mono mb-0.5">PHASE 2 — COMING SOON</div>
                  <div className="text-xl font-bold text-white">Miles: Most Intelligent Layer & Execution System</div>
                </div>
              </div>
              <div className="space-y-3">
                {[
                  "Conversational capital allocation",
                  "Inferred agent loops based on user's behavior",
                  "Real-time market intelligence",
                  "Agents that learn your risk profile",
                ].map((item) => (
                  <div key={item} className="flex items-start gap-2.5">
                    <div className="w-5 h-5 rounded-full bg-avo-lime/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <svg className="w-3 h-3 text-avo-lime" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                      </svg>
                    </div>
                    <span className="text-base text-gray-300">{item}</span>
                  </div>
                ))}
              </div>
              <div className="mt-6 pt-4 border-t border-white/5">
                <div className="text-xs text-gray-500 font-mono">
                  Coming soon...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
